import styled, { css } from 'styled-components';

import { size } from '../layout/helpers';

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

interface ItemProps {
  $reducedSpacing?: boolean;
}

export const Item = styled.li<ItemProps>`
  --_st: ${size(1.5)};

  ${({ $reducedSpacing }) =>
    $reducedSpacing &&
    css`
      --_st: ${size(0.5)};
    `}

  display: flex;
  align-items: flex-end;
  line-height: 1;

  &:not(:first-child) {
    margin-top: var(--_st);
  }
`;

export const Label = styled.div`
  flex: 1 1 auto;
`;

export const Value = styled.div`
  flex-shrink: 0;
`;
